import React from "react";
import styled from "styled-components";
import { FontSize, Spacing, content, ellipsis } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { isSocialInfluencerPlatform } from "@linkfluence/models/platform";
import Icon from "@ui-kit/icon";
import { tr } from "@radarly/i18n";
import { Influencer } from "@radarly/models/influencer";
import { InfluencerLens } from "@radarly/models/influencer/generic";

interface IProps {
  influencerLens: InfluencerLens<Influencer>;
  locale: Locale;
  className?: string;
}

const MAX_WIDTH = "100%";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.ExtraSmall};
  color: ${(props) => content(props, "secondary")};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${Spacing.Medium};
  width: ${MAX_WIDTH};
`;

const IconTextCombo = styled.div<{ isAlone: boolean }>`
  max-width: ${(props) => (props.isAlone ? "100%" : "50%")};
  display: flex;
  align-items: center;
  gap: ${Spacing.ExtraSmall};

  p {
    ${ellipsis(MAX_WIDTH)};
  }
`;

const StyledIcon = styled(Icon)`
  flex-shrink: 0;
`;

const Description = styled.p`
  ${ellipsis(MAX_WIDTH)};
  font-size: ${FontSize.Medium};
`;

const RadarlyAuthorDetails = ({
  influencerLens,
  locale,
  className,
}: IProps) => {
  const occupation = influencerLens.getOccupation();
  const country = influencerLens.getCountry();
  const description = influencerLens.getDescription();
  const platform = influencerLens.getPlatform();

  const isSocial = isSocialInfluencerPlatform(platform);

  return (
    <Root className={className}>
      <Wrapper>
        {occupation && (
          <IconTextCombo isAlone={!country}>
            <StyledIcon glyph="suitcase" />
            <p>{occupation}</p>
          </IconTextCombo>
        )}
        {country && isSocial && (
          <IconTextCombo isAlone={!occupation}>
            <StyledIcon glyph="localisation" />
            <p>{tr(locale, "COUNTRIES::" + country)}</p>
          </IconTextCombo>
        )}
      </Wrapper>

      {description && <Description>{description}</Description>}
    </Root>
  );
};

export default RadarlyAuthorDetails;
